import React, { Component } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  CardHeader,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col
} from "reactstrap";
import classnames from "classnames";
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactLoading from "react-loading";
import SupportUsersList from "./SupportUsersList";
import Heading from "./Heading";
import CreateUserModal from "./CreateUserModal";
import supportTeamImage from "../../../files/support-team.png";
import { USERS_ROLE } from "../../../constants/role.constant";
import { pasteValue } from "../../Reusable/OnPasteValue";
const _ = require("lodash");
class AdminSupport extends Component {  
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      modal: false,
      modal2: false,
      modalUser: false,
      emailOffer: "",
      emailAccess: "",
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      showAlertSuccess: false,
      errorPassword: false,
      isStaff: false,
      isCareProvider: false,
      role: USERS_ROLE.find((item) => item.type === "support")?.value ?? "support",
      filteredSupports: props.supports || [],
      editSupportUsersDetails: null,
      isEditMode: false
    };
    this.toggleUser = this.toggleUser.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.getSupportUsers = this.getSupportUsers.bind(this);
    this.searchTimeout = null;
  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState((prevState) => ({
      [name]: value,
      editSupportUsersDetails: {
         ...prevState.editSupportUsersDetails,
        [name]: value
      }
    }));
    if (name === "confirmpassword") {
      const checkMatch = this.state.password === value;

      if (!checkMatch) {
        this.setState({ errorPassword: true });
      } else {
        this.setState({ errorPassword: false });
      }
    }
  }
  resetForm() {
    this.setState({
      modal2: false,
      modal: false,
      modalUser: false,
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      role: "",
      isClient: true,
      isCareProvider: true,
      organization: ""
    });
    this.setState({isEditMode : false, editSupportUsersDetails : null})
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
    this.props.dispatch({
      type: "DO_GET_SUPPORTS",
      payload: { client: true }
    });
    // this.props.dispatch({
    //   type: "DO_GET_USERS_READING_UNDER_YOUR_ORGANIZATION"
    // });
  }
  submitUser(e) {
    e.preventDefault();
    const cleanUser = _.omit(this.state, [
      "activeTab",
      "modal",
      "modal2",
      "modalUser",
      "emailOffer",
      "confirmpassword",
      "emailAccess",
      "showAlertSuccess",
      "errorPassword",
      "filteredSupports",
      "editSupportUsersDetails",
      "isEditMode",
      "isClient"
    ]);
    if (this.state.isEditMode) {
      this.props.dispatch({
        type: "DO_EDIT_SUPPORT_USER",
        payload: this.state.editSupportUsersDetails
      });
    } else {
      this.props.dispatch({
        type: "DO_SAVE_SUPPORT_USER",
        payload: cleanUser
      });
    }
  }
  toggleUser() {
    this.setState({
      modalUser: !this.state.modalUser,
      editSupportUsersDetails: null,
      isEditMode: false
    });
  }
  toggleModal() {
    
    this.setState({
      modal: !this.state.modal
    });
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
  componentDidMount() {
    this.props.dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
    this.props.dispatch({
      type: "DO_REMOVE_PROFILE_DATA"
    });
    this.props.dispatch({
      type: "DO_GET_SUPPORTS",
      payload: { client: true }
    });

    // this.props.dispatch({
    //   type: "DO_GET_USERS_READING_UNDER_YOUR_ORGANIZATION"
    // });
  }

  getSupportUsers(event){
    if(event){
      this.props.dispatch({
        type: "DO_GET_SUPPORTS",
        payload: { client: true }
      });
    }
  }

  handleSearch = (event) => {
    const value = event.target.value;
    clearTimeout(this.searchTimeout); // clear previous timer

    this.searchTimeout = setTimeout(() => {
      const searchText = value.toLowerCase();

      const filtered = this.props.supports.filter((user) => {
        const fullName = (user.fname || "") + " " + (user.lname || "");
        return (
          fullName.toLowerCase().includes(searchText) ||
          (user.phone || "").toLowerCase().includes(searchText) ||
          (user.organization || "").toLowerCase().includes(searchText) ||
          (user.email || "").toLowerCase().includes(searchText) ||
          (user.username || "").toLowerCase().includes(searchText) ||
          (user.organization || "").toLowerCase().includes(searchText)
        );
      });

      this.setState({ filteredSupports: filtered });
    }, 400);
  };

  handleEdit = (data) => {
    if (data) {
      this.setState({ editSupportUsersDetails: data, modalUser: !this.state.modalUser, isEditMode : true })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.supports !== this.props.supports) {
      this.setState({
        filteredSupports: this.props.supports || []
      });
    }
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body project-tab pt-2">
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                    <img src={supportTeamImage} className="mr-2" alt="image"  style={{ height: "47px" }}/>
                      <span>
                       {" "} SUPPORT USERS
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row>
                  <Col sm="12" className="grid-margin mt-4">
                  <div className="d-flex flex-column flex-sm-row w-100 align-items-stretch mb-3 gap-2 gap-sm-4">
                  <input
                    type="text"
                    className="form-control input-date-filter remove-bottom-margin mb-2 mb-sm-0"
                    id="exampleInputName1Test"
                    style={{
                      fontSize: "16px",
                      borderRadius: "8px",
                      boxShadow: "none",
                      height: "44px",
                      flex: 1,
                    }}
                    placeholder="Search name, username, email, phone number, organization..."
                    onChange={this.handleSearch} // Call handleChange on every input change
                    onPaste={(e) => {
                      e.preventDefault();
                      const event = pasteValue(e);
                      this.handleSearch(event);
                    }}
                  />
                  <button
                    className="btn btn-info d-flex align-items-center justify-content-center flex-shrink-0 ml-md-2"
                    style={{
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: "16px",
                      padding: "10px 16px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                      whiteSpace: "nowrap",
                      minHeight: "44px",
                    }}
                    onClick={this.toggleModal}
                  >
                    <i className="mdi mdi-plus-circle-outline mr-0 mr-sm-2" style={{ fontSize: "20px" }} />
                    <span className="d-none d-sm-inline">Create a New Support</span>
                    <span className="d-sm-none">Create Support</span>
                  </button>
                </div>
                    {this.props.ongoingGetSupportUserRequest && (
                      <ReactLoading className="mx-auto" type="spin" color="blue" height={60} width={60} />
                    )}

                    {!this.props.ongoingGetSupportUserRequest && (
                      <SupportUsersList
                        supportUsers={this.state.filteredSupports}
                        getSupportUsers={this.getSupportUsers}
                        loading={this.props.ongoingGetSupportUserRequest}
                        handleEdit={this.handleEdit}
                      />
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleModal}>
            Create a New Support
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <h5 className="text-center" />
            <div className="row">
              {/* <div className="col-6">
                <NavLink
                  className="text-center d-block"
                  onClick={this.openInvite}
                >
                  <img
                    src="https://image.flaticon.com/icons/svg/201/201618.svg"
                    style={{ height: "180px" }}
                  />
                  <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                    INVITE A USER
                  </span>
                  <small>Send a sign up link</small>
                </NavLink>
              </div> */}
              <div className="col-6 mx-auto">
                <NavLink
                  className="text-center d-block"
                  onClick={this.toggleUser}
                >
                  <img src={supportTeamImage} style={{ height: "180px" }} />
                  <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                    CREATE A NEW SUPPORT ACCOUNT
                  </span>
                  <small>You will input everything</small>
                </NavLink>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <SweetAlert
          success
          title="Success!"
          show={this.props.isGenericSuccess}
          onConfirm={() => this.resetForm()}
          confirmBtnBsStyle="info"
        >
          {this.state.bday && <div>Support User Created Successfully</div>}
        </SweetAlert>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message || "Something went wrong. Please try again"}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR"
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        >
        </SweetAlert>
        <CreateUserModal
          modalUser={this.state.modalUser}
          toggleUser={this.toggleUser}
          errorPassword={this.state.errorPassword}
          submitUser={this.submitUser}
          handleInputChange={this.handleInputChange}
          formData={this.state.editSupportUsersDetails}
          isEditMode={this.state.isEditMode}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user, auth, client }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    usersOfferedAccess,
    usersOfferedAccessOrganization,
    ongoingGetSupportUserRequest
  } = careprovider;
  const { supports } = client;

  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    usersOfferedAccess,
    usersOfferedAccessOrganization,
    supports,
    ongoingGetSupportUserRequest
  };
};

export default connect(mapStateToProps)(AdminSupport);
